// extracted by mini-css-extract-plugin
module.exports = {"otpInputContainer":"OTPField_otpInputContainer___4NVX","otpInput":"OTPField_otpInput__K32Cl","otpInputFocus":"OTPField_otpInputFocus__GQOss"};